import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ht from "../../Images/T_logo_rgb_n.svg";
import iskon from "../../Images/logo-iskon.svg";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";
import { Link } from "react-router-dom";

const Navbar = ({ className }) => {
  const { t: translator } = useTranslation();
  const { isActiveMenu, toggleMenu } = useContext(GlobalContext);
  const { roleId, tenantId } = useContext(AuthContext);
  const { master, admin, support } = roles;

  return (
    <nav className={`navbar navbar-expand-lg brand-color p-0 ${className}`}>
      <span className="menu-toggler " onClick={toggleMenu}>
        {isActiveMenu ? (
          ""
        ) : (
          <i className="icon icon-hamburger-button text-light"></i>
        )}
      </span>
      <Link
        to={
          [master, admin, support].includes(Number(roleId))
            ? "/"
            : `/tenants/${tenantId}`
        }
        className="navbar-brand"
      >
        <img
          src={window.REACT_APP_VENDOR === "ht" ? ht : ht}
          alt="logo"
          id={`logo-login-${window.REACT_APP_VENDOR}`}
        />
      </Link>
      <ul className="navbar-nav ml-auto pr-4">
        <li className="text-light text-uppercase">
          <span
            className="text-light mt-2 mob-hidden"
            style={{ textTransform: "uppercase", fontWeight: "600" }}
          >
            {translator("Common-Navbar-Title")}
          </span>
          <span
            className="text-light mt-2 web-hidden"
            style={{ textTransform: "uppercase", fontWeight: "600" }}
          >
            PFB
          </span>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
